import { NonIdealState } from "@blueprintjs/core";
import styled from "styled-components";

export const StyledNonIdealState = styled(NonIdealState)`
  //border: solid 1px rgba(16, 22, 26, 0.15);
  border-top: none;
  padding-bottom: 1rem;
`;
